var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconThumbUpFill = function SvgIconThumbUpFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    fill: "none",
    viewBox: "0 0 23 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20 7.62q.762 0 1.333.571.57.57.571 1.333v1.905a2 2 0 0 1-.143.714l-2.857 6.715a1.92 1.92 0 0 1-.714.81 1.86 1.86 0 0 1-1.048.332H9.523q-.785 0-1.345-.559a1.83 1.83 0 0 1-.56-1.345v-9.69q0-.382.155-.727t.417-.607l5.167-5.143q.357-.333.845-.405.488-.071.94.167.453.237.655.667.203.428.083.88L14.81 7.62zM3.81 20q-.787 0-1.346-.559a1.83 1.83 0 0 1-.56-1.345V9.524q0-.786.56-1.345.56-.56 1.345-.56.786 0 1.345.56.56.56.56 1.345v8.572q0 .785-.56 1.345t-1.345.56"
  })));
};
export default SvgIconThumbUpFill;